import React from 'react';
import CargomaticModal from 'components/v2/modal';
import XIcon from 'components/v2/icons/XIcon';
import { ConfirmationModal } from './OfferPlannerModalContainer';
const OfferPlannerModal = (props) => {
    const useRenderer = props.body.modalHeaderControlled &&
        typeof props.body.modalHeaderControlled === 'function';
    const renderBody = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex justify-start px-4" },
                !props.body.modalHeaderControlled &&
                    props.body.modalHeaders.map((mHeader) => {
                        return React.createElement("h1", { className: "text-sm" }, mHeader);
                    }),
                useRenderer &&
                    props.body.modalHeaderControlled(props.items, props.type)),
            React.createElement("div", { className: "px-4 mx-auto overflow-auto max-h-96" },
                React.createElement("button", { onClick: () => props.onClose(), className: "absolute top-4 right-4" },
                    React.createElement(XIcon, null)),
                React.createElement("table", { className: " mx-auto mt-2 mb-12" },
                    React.createElement("thead", null,
                        React.createElement("tr", { className: "bg-gray-100 text-gray-500 uppercase text-xs" }, props.body.tableHeaders.map((tHeader) => {
                            return (React.createElement("th", { className: "py-1 pr-10 text-center whitespace-nowrap" }, tHeader));
                        }))),
                    React.createElement("tbody", null, props.body.tableRows(props.items, props.setItems, props.offerPlanners, props.offerPlannersIndex, props.setConfirmationModal, props.type))),
                props.confirmationModal &&
                    props.confirmationModal.action &&
                    ConfirmationModal(props.confirmationModal, () => props.setConfirmationModal({}), props.refreshData, props.setItems, props.type, props.setLoading))));
    };
    return (React.createElement(CargomaticModal, { showHeader: false, show: props.show, onHide: props.onClose, body: renderBody(), dialogClassName: props.body.widthClass }));
};
export default OfferPlannerModal;
